__turbopack_context__.v({
  "blur": "game-module__GPwVNq__blur",
  "buttonQueue": "game-module__GPwVNq__buttonQueue",
  "content": "game-module__GPwVNq__content",
  "contentTrailer": "game-module__GPwVNq__contentTrailer",
  "controls": "game-module__GPwVNq__controls",
  "controlsWrapper": "game-module__GPwVNq__controlsWrapper",
  "data": "game-module__GPwVNq__data",
  "disclaimer": "game-module__GPwVNq__disclaimer",
  "discountRibbon": "game-module__GPwVNq__discountRibbon",
  "game": "game-module__GPwVNq__game",
  "genres": "game-module__GPwVNq__genres",
  "heading": "game-module__GPwVNq__heading",
  "highlightedText": "game-module__GPwVNq__highlightedText",
  "label": "game-module__GPwVNq__label",
  "main": "game-module__GPwVNq__main",
  "maintenance": "game-module__GPwVNq__maintenance",
  "maintenanceIcon": "game-module__GPwVNq__maintenanceIcon",
  "playButton": "game-module__GPwVNq__playButton",
  "trailer": "game-module__GPwVNq__trailer",
  "trailerImage": "game-module__GPwVNq__trailerImage",
  "trailerWrapper": "game-module__GPwVNq__trailerWrapper",
  "volume": "game-module__GPwVNq__volume",
});
